import { useNavigate } from "react-router-dom";
import IconEcac from "@icons/IconEcac";
import MessageServices from "@services/MessageServices";
import usePermissoes from "./usePermissoes";
import EndPointServices from "@services/ApiServices";

export default function useLst() {
  const navigate = useNavigate();
  const { handlePermissoes } = usePermissoes();

  //Lista de Apps
  const lstApps = [
    {
      icon: "<i class='fa-solid fa-users'></i>",
      desc: "CAD",
      id: 2,
      onClick: () => {
        navigate("/CAD");
      },
      background: "#373148",
      title: "Cadastro e Organização de suas empresas!",
    },
    {
      icon: "<i class='fa-solid fa-truck-ramp-box'></i>",
      desc: "CT-e",
      id: 1,
      onClick: () => {
        navigate("/CTe");
      },
      background: "#5A37CC",
      title: "Gestão e controle dos Ctes em Desacordo!",
    },
    {
      icon: <IconEcac width="25" />,
      tpIcon: "svg",
      desc: "E-cac",
      id: 3,
      onClick: () => {
        navigate("/ECAC/SituacaoFiscal");
      },
      background: "#5A75F1",
      title: "Solução para Instabilidade no e-CAC e Gestão de Pendências!",
    },
  ];
  //Lista de Perfil #Desativar Temporariamente.
  const lstMenu_Perfil = [
    {
      icon: "<i class='fa-solid fa-user'></i>",
      desc: "Perfil",
      onClick: () => {
        MessageServices.ShowWarning("#EmDesenvolvimento!");
      },
    },
    {
      icon: "",
      desc: "",
      onClick: () => {
        MessageServices.ShowWarning("#EmDesenvolvimento!");
      },
    },
  ];
  //Lista do APP CAD
  const lstCAD_MenuInterativo = [
    {
      id: 1,
      icon: "<i class='fa-solid fa-phone'></i>",
      title: "Contatos",
      top: "0px",
      menususpensolateral: true,
      permissao: {
        consultar: !handlePermissoes(2, "Contato", "Consultar"),
        editar: !handlePermissoes(2, "Contato", "Editar"),
        inativar: !handlePermissoes(2, "Contato", "Inativar"),
        criar: !handlePermissoes(2, "Contato", "Criar"),
      },
      endPoint: {
        consultar: EndPointServices.CAD_ContatoConsultar,
        editar: EndPointServices.CAD_ContatoEditar,
      },
    },
    {
      id: 2,
      icon: "<i class='fa-solid fa-handshake'></i>",
      title: "Socios",
      top: "60px",
      menususpensolateral: false,
      ref: "#socio",
      permissao: {
        consultar: !handlePermissoes(2, "Socio", "Consultar"),
        editar: !handlePermissoes(2, "Socio", "Editar"),
        inativar: !handlePermissoes(2, "Socio", "Inativar"),
        criar: !handlePermissoes(2, "Socio", "Criar"),
      },
    },
    {
      id: 3,
      icon: "<i class='fa-solid fa-address-card'></i>",
      title: "Dados Empresa",
      menususpensolateral: false,
      ref: "#dadosEmpresa",
      permissao: {
        consultar: !handlePermissoes(2, "DadosEmpresa", "Consultar"),
        editar: !handlePermissoes(2, "DadosEmpresa", "Editar"),
        inativar: !handlePermissoes(2, "DadosEmpresa", "Inativar"),
        criar: !handlePermissoes(2, "DadosEmpresa", "Criar"),
      },
    },
    {
      id: 6,
      icon: "<i class='fa-solid fa-database'></i>",
      title: "Dados do Sócio",
      menususpensolateral: false,
      ref: "#dadosdosocio",
      permissao: {
        consultar: !handlePermissoes(2, "Socio", "Consultar"),
        editar: !handlePermissoes(2, "Socio", "Editar"),
        inativar: !handlePermissoes(2, "Socio", "Inativar"),
        criar: !handlePermissoes(2, "Socio", "Criar"),
      },
    },
    {
      id: 4,
      icon: "<i class='fa-solid fa-location-dot'></i>",
      title: "Endereço",
      menususpensolateral: false,
      ref: "#endereco",
      permissao: {
        consultar: !handlePermissoes(2, "DadosEmpresa", "Consultar"),
        editar: !handlePermissoes(2, "DadosEmpresa", "Editar"),
        inativar: !handlePermissoes(2, "DadosEmpresa", "Inativar"),
        criar: !handlePermissoes(2, "DadosEmpresa", "Criar"),
      },
    },
    // {
    //   id: 5,
    //   icon: "<i class='fa-solid fa-file-invoice-dollar'></i>",
    //   title: "Notas Fiscais",
    //   menususpensolateral: false,
    //   ref: "#notasfiscais",
    //   permissao: {
    //     consultar: !handlePermissoes(2, "NotasFiscais", "Consultar"),
    //     editar: !handlePermissoes(2, "NotasFiscais", "Editar"),
    //     inativar: !handlePermissoes(2, "NotasFiscais", "Inativar"),
    //     criar: !handlePermissoes(2, "NotasFiscais", "Criar"),
    //   },
    // },
  ];
  //lista nacionalidades
  const lstNacionalidade = [
    { id: 1, key: "Afegão(ã)" },
    { id: 2, key: "Sul-africano(a)" },
    { id: 3, key: "Albanês(esa)" },
    { id: 4, key: "Alemão(ã)" },
    { id: 5, key: "Andorrano(a)" },
    { id: 6, key: "Angolano(a)" },
    { id: 7, key: "Antiguano(a)" },
    { id: 8, key: "Saudita" },
    { id: 9, key: "Argelino(a)" },
    { id: 10, key: "Argentino(a)" },
    { id: 11, key: "Armênio(a)" },
    { id: 12, key: "Australiano(a)" },
    { id: 13, key: "Austríaco(a)" },
    { id: 14, key: "Azerbaijano(a)" },
    { id: 15, key: "Bahamense" },
    { id: 16, key: "Bangladeshiano(a)" },
    { id: 17, key: "Barbadiano(a)" },
    { id: 18, key: "Bahrainita" },
    { id: 19, key: "Belga" },
    { id: 20, key: "Belizenho(a)" },
    { id: 21, key: "Beninense" },
    { id: 22, key: "Bielorrusso(a)" },
    { id: 23, key: "Boliviano(a)" },
    { id: 24, key: "Bósnio(a)" },
    { id: 25, key: "Botsuanense" },
    { id: 26, key: "Brasileiro(a)" },
    { id: 27, key: "Britânico(a)" },
    { id: 28, key: "Bruneano(a)" },
    { id: 29, key: "Búlgaro(a)" },
    { id: 30, key: "Burquinense" },
    { id: 31, key: "Burundiano(a)" },
    { id: 32, key: "Butanês(esa)" },
    { id: 33, key: "Cabo-verdiano(a)" },
    { id: 34, key: "Cameronês(esa)" },
    { id: 35, key: "Canadense" },
    { id: 36, key: "Catariano(a)" },
    { id: 37, key: "Chadiano(a)" },
    { id: 38, key: "Chileno(a)" },
    { id: 39, key: "Chinês(esa)" },
    { id: 40, key: "Cingalês(esa)" },
    { id: 41, key: "Colombiano(a)" },
    { id: 42, key: "Comorense" },
    { id: 43, key: "Congolês(esa)" },
    { id: 44, key: "Costarriquenho(a)" },
    { id: 45, key: "Croata" },
    { id: 46, key: "Cubano(a)" },
    { id: 47, key: "Dinamarquês(esa)" },
    { id: 48, key: "Dominicano(a)" },
    { id: 49, key: "Egípcio(a)" },
    { id: 50, key: "Equatoriano(a)" },
    { id: 51, key: "Eritreu(ia)" },
    { id: 52, key: "Eslovaco(a)" },
    { id: 53, key: "Esloveno(a)" },
    { id: 54, key: "Espanhol(a)" },
    { id: 55, key: "Estoniano(a)" },
    { id: 56, key: "Etíope" },
    { id: 57, key: "Filipino(a)" },
    { id: 58, key: "Finlandês(esa)" },
    { id: 59, key: "Francês(esa)" },
    { id: 60, key: "Gabonês(esa)" },
    { id: 61, key: "Gambiano(a)" },
    { id: 62, key: "Ganês(esa)" },
    { id: 63, key: "Georgiano(a)" },
    { id: 64, key: "Grego(a)" },
    { id: 65, key: "Guatemalteco(a)" },
    { id: 66, key: "Guineense" },
    { id: 67, key: "Haitiano(a)" },
    { id: 68, key: "Hondurenho(a)" },
    { id: 69, key: "Húngaro(a)" },
    { id: 70, key: "Indiano(a)" },
    { id: 71, key: "Indonésio(a)" },
    { id: 72, key: "Iraniano(a)" },
    { id: 73, key: "Iraquiano(a)" },
    { id: 74, key: "Irlandês(esa)" },
    { id: 75, key: "Israelense" },
    { id: 76, key: "Italiano(a)" },
    { id: 77, key: "Jamaicano(a)" },
    { id: 78, key: "Japonês(esa)" },
    { id: 79, key: "Jordaniano(a)" },
    { id: 80, key: "Letão(ã)" },
    { id: 81, key: "Libanês(esa)" },
    { id: 82, key: "Lituano(a)" },
    { id: 83, key: "Luxemburguês(esa)" },
    { id: 84, key: "Malaio(a)" },
    { id: 85, key: "Mexicano(a)" },
    { id: 86, key: "Moçambicano(a)" },
    { id: 87, key: "Nepalês(esa)" },
    { id: 88, key: "Neozelandês(esa)" },
    { id: 89, key: "Nicaraguense" },
    { id: 90, key: "Norueguês(esa)" },
    { id: 91, key: "Panamenho(a)" },
    { id: 92, key: "Paraguaio(a)" },
    { id: 93, key: "Peruano(a)" },
    { id: 94, key: "Polonês(esa)" },
    { id: 95, key: "Português(esa)" },
    { id: 96, key: "Queniano(a)" },
    { id: 97, key: "Romeno(a)" },
    { id: 98, key: "Russo(a)" },
    { id: 99, key: "Sueco(a)" },
    { id: 100, key: "Suíço(a)" },
    { id: 101, key: "Turco(a)" },
    { id: 102, key: "Ucraniano(a)" },
    { id: 103, key: "Uruguaio(a)" },
    { id: 104, key: "Venezuelano(a)" },
    { id: 105, key: "Vietnamita" },
  ];

  return { lstApps, lstMenu_Perfil, lstCAD_MenuInterativo, lstNacionalidade };
}
